"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _Switch = _interopRequireDefault(require("@react/react-spectrum/Switch"));

var _useIngest = _interopRequireDefault(require("../../hooks/useIngest"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var GlobalCommentingSwitch = function GlobalCommentingSwitch(_ref) {
  var visible = _ref.visible,
      defaultChecked = _ref.defaultChecked,
      onToggle = _ref.onToggle,
      disable = _ref.disable,
      viewingUnmapped = _ref.viewingUnmapped,
      setUnmappedView = _ref.setUnmappedView,
      globalCommentsMode = _ref.globalCommentsMode;
  var ccxIngest = (0, _useIngest.default)();
  var handleViewChange = (0, _react.useCallback)(function (isActive) {
    onToggle(isActive);

    if (!isActive && viewingUnmapped) {
      setUnmappedView(false);
    }

    globalCommentsMode ? ccxIngest.fireEvent(ccxIngest.events.showNonGlobal) : ccxIngest.fireEvent(ccxIngest.events.showGlobal);
  }, [ccxIngest, globalCommentsMode, viewingUnmapped, setUnmappedView, onToggle]);
  return visible ? /*#__PURE__*/_react.default.createElement("div", {
    className: "view-switch-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_Switch.default, {
    defaultChecked: defaultChecked,
    disabled: disable,
    id: "ccx-comments-switch-view",
    onChange: handleViewChange
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "switch-label",
    htmlFor: "ccx-comments-switch-view"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "comments.filter.all_screens"
  }))) : null;
};

GlobalCommentingSwitch.defaultProps = {
  disable: false,
  viewingUnmapped: false
};
GlobalCommentingSwitch.propTypes = {
  defaultChecked: _propTypes.default.bool.isRequired,
  disable: _propTypes.default.bool,
  globalCommentsMode: _propTypes.default.bool.isRequired,
  onToggle: _propTypes.default.func.isRequired,
  setUnmappedView: _propTypes.default.func.isRequired,
  viewingUnmapped: _propTypes.default.bool,
  visible: _propTypes.default.bool.isRequired
};
var _default = GlobalCommentingSwitch;
exports.default = _default;